import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// ponytail: not inflection.capitalize — that lowercases the rest ("McDonald" → "Mcdonald").
export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
